import { IFigure, ISortDirectionType, IUser } from "src/types/common";

export enum EnumLeverageProductsIndication {
    AllWikifolios = 0,
    WikifoliosWithLeverageProducts = 1,
    WikifoliosWithoutLeverageProducts = 2,
}

export interface IExtendedSearchTrader extends Pick<IUser, "id" | "firstName" | "lastName" | "nickName" | "isDeleted"> {
    isProfilePictureAvailable: boolean;
    traderImageUrl: string;
}

export interface IExtendedSearchItem {
    wikifolioId: string;
    symbol: string;
    wikifolioShortDescription: string;
    trader: IExtendedSearchTrader;
    figures: IFigure[];
    isOnWatchlist?: boolean;
    isInvestable?: boolean;
    tags?: string[];
}

export interface IExtendedSearchResponse {
    totalResults: number;
    results: IExtendedSearchItem[];
}

export interface IKeyFiguresRequest {
    id: string;
    min?: number;
    max?: number;
}

export interface ISearchRequestParams {
    query?: string;
    country: string;
    sortDirection?: ISortDirectionType;
    sortByRankingId?: string | null;
    offset?: number;
    tagsIds?: readonly string[];
    brokersIds?: readonly string[];
    keyFigures?: readonly IKeyFiguresRequest[];
    isInvestable?: boolean;
    isAtInvestable?: boolean;
    isChInvestable?: boolean;
    leverageProductsIndication?: EnumLeverageProductsIndication;
    wikifolioIsins?: string[];
    excludeNoMarketing?: boolean;
    limit?: number;
    selectedFigures?: string[];
}

export type ISearchRequestParamsOmitCountry = Omit<ISearchRequestParams, "country">;
